import React from 'react'
import Footer from "../../components/footer";
import Header from "../../components/header/index";
// import InnerHeaderBooking from "./innerheadercar/headerBokingList";
// import InnerHeaderCheckout from "../../components/comment/innerHeader/innerHeaderCheckout";
import InnerHeaderCompleteBooking from '../../components/comment/innerHeader/InnnerHeaderIcon';
import CompletedBooking from './completedbookingcontent/completedcontent';


const completedBooking = () => {
  return (
    <div className="main">
      <Header />
      <InnerHeaderCompleteBooking title="Completed Booking " />
     <CompletedBooking />
      <Footer />
    </div>
  )
}

export default completedBooking